import {Injectable} from '@angular/core';
import {NativeDateAdapter} from '@angular/material/core';

@Injectable()
export class PtBrDateAdapter extends NativeDateAdapter {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const clean = value.trim();

      const digits = clean.replace(/\D/g, '');
      if (digits.length === 8) {
        const d = Number(digits.slice(0, 2));
        const m = Number(digits.slice(2, 4));
        const y = Number(digits.slice(4, 8));
        const date = new Date(y, m - 1, d);
        return this.isValid(date) ? date : null;
      }

      const asDate = new Date(clean);
      return this.isValid(asDate) ? asDate : null;
    }
    return value instanceof Date && !isNaN(value.getTime()) ? value : null;
  }

  public override isValid(date: Date) {
    return date instanceof Date && !isNaN(date.getTime());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  override format(date: Date, __: any): string {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
}
